import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import AppWizard from "../../../shared/appWizard/appWizard";
import SuccessBox from "../../../shared/successBox/successBox";
import GcpCreation from "./gcpCreation";

import { useDispatch } from "react-redux";
import { createGcpIntegration } from "../../../redux/actions/gcpIntegrationActions";
import { integrationIcons } from "../../../utils/icons";

import "./gcpIntegration.scss";

const GcpIntegration = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [wizardState, setWizardState] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const configWizard = [
    {
      step_title: "Setup",
      step_description: "Google Cloud Storage Integration details",
      content_title: "Google Cloud Storage Integration",
      content: (
        <GcpCreation
          wizardState={wizardState}
          setWizardState={setWizardState}
          setSubmitDisabled={setSubmitDisabled}
        />
      ),
      valid: true,
      beforeNextStep: async () => {
        setLoadingSubmit(true);

        const result = await dispatch(
          createGcpIntegration(
            wizardState.name,
            wizardState.projectId,
            wizardState.serviceAccountKey
          )
        );
        setLoadingSubmit(false);
        if (!result?.ok) {
          throw new Error(
            `Failed to create Google Cloud integration.`
          );
        }
      },
    },
    {
      step_title: "Completion",
      step_description: "",
      content_title: "Integration Created!",
      content: (
        <SuccessBox
          setSubmitDisabled={setSubmitDisabled}
          subTitle="The Resources from the Integration will take up to one hour to appear in the inventory"
          doesTakeTime={true}
        />
      ),
      valid: true,
    },
  ];

  return (
    <div className="GcpIntegration">
      <AppWizard
        loadingSubmit={loadingSubmit}
        configWizard={configWizard}
        handleClose={() => history.goBack()}
        submitDisabled={submitDisabled}
        setSubmitDisabled={setSubmitDisabled}
        handleSubmit={() => history.push("/integrations")}
        iconSrc={integrationIcons["gcs"]}
      />
    </div>
  );
};

export default GcpIntegration;
